import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Constants } from "src/@smartmanufacturing/common/constants";

@Injectable({
  providedIn: 'root'
})
export class BatchReportService {
  // tslint:disable-next-line:typedef
  // baseUrl: string = environment.O3CoreApiUrl;
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getItemCode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetItemInfo', data);
  }
  getProcessOrder(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetProcessOrder', data);
  }
  getBatchReport(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetBatchItemBOMList', data);
  }
  getBatchItemBOMReport(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetBatchItemBOMInfo', data);
  }
  getProductDD(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'Variable/GetAllMappedProductCode');
  }
  getProductSpecification(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetProductSpecificationByMachine', data);
  }
  getBatchOutReport(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetBatchOutputList', data);
  }
  getJobBatchInfoDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetJbBatchchecklistDetails', data);
  }

  getProcessOrderByPlant(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetProcessOrderByPlant', data);
  }

  getInputReport(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'BatchReport/GetProductionInputList', data);
  }

}